import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { palette } from "./palette";
export var actionColors = {
  actionInactive: palette.gray13,
  actionInverted: palette.white
};
export var actionPrimaryColors = {
  actionPrimary: palette.blue10,
  actionPrimaryHover: palette.blue09,
  actionPrimaryPressed: palette.blue08
};
export var actionSecondaryColors = {
  actionSecondary: palette.gray10,
  actionSecondaryHover: palette.gray09,
  actionSecondaryPressed: palette.gray08
};
export var actionPositiveColors = {
  actionPositive: palette.green10,
  actionPositiveHover: palette.green09,
  actionPositivePressed: palette.green08
};
export var actionWarningColors = {
  actionWarning: palette.amber10,
  actionWarningHover: palette.amber09,
  actionWarningPressed: palette.amber08
};
export var actionNegativeColors = {
  actionNegative: palette.red10,
  actionNegativeHover: palette.red09,
  actionNegativePressed: palette.red08
};
export var actionMagicColors = {
  actionMagic: palette.violet10,
  actionMagicHover: palette.violet09,
  actionMagicPressed: palette.violet08
};
export var bgColors = {
  bgRegular: palette.white,
  bgRegularHover: palette.gray21,
  bgRegularPressed: palette.gray20,
  bgInactive: palette.gray21
};
export var bgPrimaryColors = {
  bgPrimary: palette.blue20,
  bgPrimaryHover: palette.blue19,
  bgPrimaryPressed: palette.blue18
};
export var bgPrimaryHighlightColors = {
  bgPrimaryHighlight: palette.blue20,
  bgPrimaryHighlightHover: palette.blue19,
  bgPrimaryHighlightPressed: palette.blue18
};
export var bgSecondaryColors = {
  bgSecondary: palette.gray20,
  bgSecondaryHover: palette.gray19,
  bgSecondaryPressed: palette.gray18
};
export var bgSecondaryHighlightColors = {
  bgSecondaryHighlight: palette.gray21,
  bgSecondaryHighlightHover: palette.gray20,
  bgSecondaryHighlightPressed: palette.gray19
};
export var bgMagicColors = {
  bgMagic: palette.violet20,
  bgMagicHover: palette.violet19,
  bgMagicPressed: palette.violet18
};
export var bgMagicHighlightColors = {
  bgMagicHighlight: palette.violet21,
  bgMagicHighlightHover: palette.violet20,
  bgMagicHighlightPressed: palette.violet19
};
export var bgWarningColors = {
  bgWarning: palette.amber20,
  bgWarningHover: palette.amber19,
  bgWarningPressed: palette.amber18
};
export var bgWarningHighlightColors = {
  bgWarningHighlight: palette.amber21,
  bgWarningHighlightHover: palette.amber20,
  bgWarningHighlightPressed: palette.amber19
};
export var bgPositiveColors = {
  bgPositive: palette.green20,
  bgPositiveHover: palette.green19,
  bgPositivePressed: palette.green18
};
export var bgPositiveHighlightColors = {
  bgPositiveHighlight: palette.green21,
  bgPositiveHighlightHover: palette.green20,
  bgPositiveHighlightPressed: palette.green19
};
export var bgNegativeColors = {
  bgNegative: palette.red20,
  bgNegativeHover: palette.red19,
  bgNegativePressed: palette.red18
};
export var bgNegativeHighlightColors = {
  bgNegativeHighlight: palette.red21,
  bgNegativeHighlightHover: palette.red20,
  bgNegativeHighlightPressed: palette.red19
};
export var borderColors = {
  borderInactive: palette.gray18,
  borderInverted: palette.white
};
export var borderRegularColors = {
  borderRegular: palette.gray18,
  borderRegularHover: palette.gray17,
  borderRegularPressed: palette.gray16
};
export var borderPrimaryColors = {
  borderPrimary: palette.blue15,
  borderPrimaryHover: palette.blue14,
  borderPrimaryPressed: palette.blue13
};
export var borderSecondaryColors = {
  borderSecondary: palette.gray15,
  borderSecondaryHover: palette.gray14,
  borderSecondaryPressed: palette.gray13
};
export var borderPositiveColors = {
  borderPositive: palette.green15,
  borderPositiveHover: palette.green14,
  borderPositivePressed: palette.green13
};
export var borderWarningColors = {
  borderWarning: palette.amber15,
  borderWarningHover: palette.amber14,
  borderWarningPressed: palette.amber13
};
export var borderNegativeColors = {
  borderNegative: palette.red15,
  borderNegativeHover: palette.red14,
  borderNegativePressed: palette.red13
};
export var borderMagicColors = {
  borderMagic: palette.violet15,
  borderMagicHover: palette.violet14,
  borderMagicPressed: palette.violet13
};
export var iconColors = {
  iconInactive: palette.gray15,
  iconOnAction: palette.white
};
export var iconPrimaryColors = {
  iconPrimary: palette.blue10,
  iconPrimaryHover: palette.blue09,
  iconPrimaryPressed: palette.blue08
};
export var iconPrimaryHighContrastColors = {
  iconPrimaryHighContrast: palette.blue05,
  iconPrimaryHighContrastHover: palette.blue04,
  iconPrimaryHighContrastPressed: palette.blue03
};
export var iconPrimaryLowContrastColors = {
  iconPrimaryLowContrast: palette.blue15,
  iconPrimaryLowContrastHover: palette.blue14,
  iconPrimaryLowContrastPressed: palette.blue13
};
export var iconSecondaryColors = {
  iconSecondary: palette.gray10,
  iconSecondaryHover: palette.gray09,
  iconSecondaryPressed: palette.gray08
};
export var iconSecondaryHighContrastColors = {
  iconSecondaryHighContrast: palette.gray05,
  iconSecondaryHighContrastHover: palette.gray04,
  iconSecondaryHighContrastPressed: palette.gray03
};
export var iconSecondaryLowContrastColors = {
  iconSecondaryLowContrast: palette.gray15,
  iconSecondaryLowContrastHover: palette.gray14,
  iconSecondaryLowContrastPressed: palette.gray13
};
export var iconPositiveColors = {
  iconPositive: palette.green11,
  iconPositiveHover: palette.green10,
  iconPositivePressed: palette.green09
};
export var iconPositiveHighContrastColors = {
  iconPositiveHighContrast: palette.green05,
  iconPositiveHighContrastHover: palette.green04,
  iconPositiveHighContrastPressed: palette.green03
};
export var iconPositiveLowContrastColors = {
  iconPositiveLowContrast: palette.green16,
  iconPositiveLowContrastHover: palette.green15,
  iconPositiveLowContrastPressed: palette.green14
};
export var iconWarningColors = {
  iconWarning: palette.amber12,
  iconWarningHover: palette.amber11,
  iconWarningPressed: palette.amber10
};
export var iconWarningHighContrastColors = {
  iconWarningHighContrast: palette.amber05,
  iconWarningHighContrastHover: palette.amber04,
  iconWarningHighContrastPressed: palette.amber03
};
export var iconWarningLowContrastColors = {
  iconWarningLowContrast: palette.amber17,
  iconWarningLowContrastHover: palette.amber16,
  iconWarningLowContrastPressed: palette.amber15
};
export var iconNegativeColors = {
  iconNegative: palette.red12,
  iconNegativeHover: palette.red11,
  iconNegativePressed: palette.red10
};
export var iconNegativeHighContrastColors = {
  iconNegativeHighContrast: palette.red05,
  iconNegativeHighContrastHover: palette.red04,
  iconNegativeHighContrastPressed: palette.red03
};
export var iconNegativeLowContrastColors = {
  iconNegativeLowContrast: palette.red17,
  iconNegativeLowContrastHover: palette.red16,
  iconNegativeLowContrastPressed: palette.red15
};
export var iconMagicColors = {
  iconMagic: palette.violet11,
  iconMagicHover: palette.violet10,
  iconMagicPressed: palette.violet09
};
export var iconMagicHighContrastColors = {
  iconMagicHighContrast: palette.violet05,
  iconMagicHighContrastHover: palette.violet04,
  iconMagicHighContrastPressed: palette.violet03
};
export var iconMagicLowContrastColors = {
  iconMagicLowContrast: palette.violet16,
  iconMagicLowContrastHover: palette.violet15,
  iconMagicLowContrastPressed: palette.violet14
};
export var iconInvertedColors = {
  iconInverted: '#FFFFFF',
  iconInvertedHover: palette.gray21,
  iconInvertedPressed: palette.gray20
};
export var ratingColors = {
  ratingBorder: palette.gray10,
  ratingHover: palette.blue09,
  ratingPressed: palette.blue08,
  ratingInactive: palette.gray13,
  ratingSelected: palette.blue10,
  ratingFocus: palette.blue10
};
export var cardColors = {
  cardSelected: palette.blue21
};
export var textColors = {
  textInactive: palette.gray13,
  textInverted: palette.white,
  textOnAction: palette.white
};
export var textPrimaryColors = {
  textPrimary: palette.blue09,
  textPrimaryHover: palette.blue08,
  textPrimaryPressed: palette.blue07
};
export var textPrimaryStarkColors = {
  textPrimaryStark: palette.blue05,
  textPrimaryStarkHover: palette.blue04,
  textPrimaryStarkPressed: palette.blue03
};
export var textSecondaryColors = {
  textSecondary: palette.gray10,
  textSecondaryHover: palette.gray09,
  textSecondaryPressed: palette.gray08
};
export var textSecondaryStarkColors = {
  textSecondaryStark: palette.gray05,
  textSecondaryStarkHover: palette.gray04,
  textSecondaryStarkPressed: palette.gray03
};
export var textPositiveColors = {
  textPositive: palette.green09,
  textPositiveHover: palette.green08,
  textPositivePressed: palette.green07
};
export var textPositiveStarkColors = {
  textPositiveStark: palette.green05,
  textPositiveStarkHover: palette.green04,
  textPositiveStarkPressed: palette.green03
};
export var textWarningColors = {
  textWarning: palette.amber09,
  textWarningHover: palette.amber08,
  textWarningPressed: palette.amber07
};
export var textWarningStarkColors = {
  textWarningStark: palette.amber05,
  textWarningStarkHover: palette.amber04,
  textWarningStarkPressed: palette.amber03
};
export var textNegativeColors = {
  textNegative: palette.red09,
  textNegativeHover: palette.red08,
  textNegativePressed: palette.red07
};
export var textNegativeStarkColors = {
  textNegativeStark: palette.red05,
  textNegativeStarkHover: palette.red04,
  textNegativeStarkPressed: palette.red03
};
export var textMagicColors = {
  textMagic: palette.violet09,
  textMagicHover: palette.violet08,
  textMagicPressed: palette.violet07
};
export var textMagicStarkColors = {
  textMagicStark: palette.violet05,
  textMagicStarkHover: palette.violet04,
  textMagicStarkPressed: palette.violet03
};
export var gradientColors = {
  gradientMagicPrimary: [palette.violet12, palette.blue06],
  gradientMagicPrimaryDark: [palette.violet06, palette.blue06],
  gradientNegativeMagic: [palette.red12, palette.violet07],
  gradientPrimaryPositive: [palette.blue07, palette.green13],
  gradientWarningNegative: [palette.red12, palette.amber13],
  gradientPositive: [palette.green13, palette.green09],
  gradientPrimary: [palette.blue10, palette.blue05]
};
export var colors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, actionColors), actionMagicColors), actionNegativeColors), actionPositiveColors), actionPrimaryColors), actionSecondaryColors), actionWarningColors), bgColors), bgMagicColors), bgMagicHighlightColors), bgNegativeColors), bgNegativeHighlightColors), bgPositiveColors), bgPositiveHighlightColors), bgPrimaryColors), bgPrimaryHighlightColors), bgSecondaryColors), bgSecondaryHighlightColors), bgWarningColors), bgWarningHighlightColors), borderColors), borderMagicColors), borderNegativeColors), borderPositiveColors), borderPrimaryColors), borderRegularColors), borderSecondaryColors), borderWarningColors), iconColors), iconMagicColors), iconMagicHighContrastColors), iconMagicLowContrastColors), iconNegativeColors), iconNegativeHighContrastColors), iconNegativeLowContrastColors), iconPositiveColors), iconPositiveHighContrastColors), iconPositiveLowContrastColors), iconPrimaryColors), iconPrimaryHighContrastColors), iconPrimaryLowContrastColors), iconSecondaryColors), iconSecondaryHighContrastColors), iconSecondaryLowContrastColors), iconWarningColors), iconWarningHighContrastColors), iconWarningLowContrastColors), iconInvertedColors), ratingColors), cardColors), textColors), textMagicColors), textMagicStarkColors), textNegativeColors), textNegativeStarkColors), textPositiveColors), textPositiveStarkColors), textPrimaryColors), textPrimaryStarkColors), textSecondaryColors), textSecondaryStarkColors), textWarningColors), textWarningStarkColors), gradientColors);